import { ElementRef } from '@angular/core';
import { of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { Router } from '@angular/router';

export function navigateWithFadingAnimation(
  elementToFade: ElementRef<HTMLElement>,
  navigationParams: [string, string],
  router: Router
): void {
  elementToFade.nativeElement.classList.add('animation-reverse-opacity');

  of(true)
    .pipe(delay(500))
    .subscribe(() => {
      router.navigate(navigationParams).then(r => r);
    });
}
